module.exports = __webpack_public_path__ + "img/sorry-th.b80b6b1.png";